import { observer } from "mobx-react-lite"

import type { DiagnosticCard } from "@/domains/diagnostics/types"

import { DiagnosticsIndexView } from "../views/diagnostics-index-view"

export const DiagnosticsIndexComposite = observer(() => {
  const cards: DiagnosticCard[] = [
    // {
    //   title: "Classic Pools",
    //   description: "Debug classic pools with full data available",
    //   href: "/diagnostics/classic-pools",
    // },
    // {
    //   title: "Quick Select Tokens",
    //   description: "Debug quick select tokens with full data available",
    //   href: "/diagnostics/quick-select-tokens",
    // },
    // {
    //   title: "Tokens",
    //   description: "Debug tokens with full data available",
    //   href: "/diagnostics/tokens",
    // },
    // {
    //   title: "CL Farms",
    //   description: "Debug CL Farms with full data available",
    //   href: "/diagnostics/cl-farms",
    // },
    // {
    //   title: "Recycled Emissions Chart",
    //   description: "Recycled emissions chart editor",
    //   href: "/diagnostics/recycled-emissions",
    // },
    // {
    //   title: "Wallet",
    //   description: "Debug wallet connection state and test wallet operations",
    //   href: "/diagnostics/wallet",
    // },
    {
      title: "Orchestrated Queries",
      description: "Monitor and control all orchestrated query operations",
      href: "/diagnostics/orchestrated-queries",
    },
    // {
    //   title: "System Tokens",
    //   description: "Debug system tokens with full data available",
    //   href: "/diagnostics/system-tokens",
    // },
  ]

  return <DiagnosticsIndexView cards={cards} />
})
